<template>
  <div class="directory-box">
    <div class="main-content">
      <div class="head-panel visibility">
        <div class="title">Районы вывоза мусора</div>
        <router-link to="/directories/garbage-disposal-districts/new">
          <div class="add-table-string"><i>+</i>Добавить
            район
          </div>
        </router-link>
      </div>
      <table cellpadding="0" cellspacing="0" class="garbage-area-table">
        <thead>
        <tr>
          <td>Наименование района</td>
          <td>Надбавка, руб.</td>
        </tr>
        </thead>
        <tbody>
        <tr title="Изменить" v-for="district in garbageDisposalDistricts" @value="district"
            @key="district.id" @click="openGarbageDisposalDistrict(district.id)" v-if="!district.removed">
          <td class="name"> {{ district.name }}</td>
          <td>{{ district.surcharge }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'

    export default {
  name: 'GarbageDisposalDistricts',
  components: {
    MenuDispatcher,
    HeaderDispatcher
  },

  data () {
    return {
      garbageDisposalDistricts: []
    }
  },

  mounted () {
    api
      .getGarbageDisposalDistricts()
      .then(garbageDisposalDistricts => {
        if (garbageDisposalDistricts) {
          this.garbageDisposalDistricts = []
          this.garbageDisposalDistricts = garbageDisposalDistricts
        }
      })
  },

  methods: {
    openGarbageDisposalDistrict (id) {
      this.$router.push({ name: 'GarbageDisposalDistrict', params: { id: id } })
    }
  }
}
</script>
